define('app/collections/discount_collection',['app/setup',  'app/models/discount'], function(takhfifan) {

  takhfifan.DiscountCollection = Backbone.Collection.extend({
    url: '/ajax/product/discountElements/',
    model: takhfifan.Discount
  });
});

